import { useTonAddress } from "@tonconnect/ui-react";
import { useMemo } from "react";
import { Ticker } from "../../entities/Ticker/TickerTypes";
import { ParagraphSkeletonRow } from "../../features/BuyNFTFlow/components/ParagraphSkeletonRow";
import useTonClientStore from "../../stores/TonClientStore/useTonClientStore";
import { toFixedWithoutRounding } from "../../utils/mathOperations";
import RefreshIcon from "../Icons/RefreshIcon";
import s from "./InsufficientFunds.module.scss";

type Props = {
  ticker: Ticker;
  isBottomMarginNeeded?: boolean;
};

export const InsufficientFunds: React.FC<Props> = ({
  ticker,
  isBottomMarginNeeded = true,
}) => {
  const tonClientStore = useTonClientStore();
  const userAddress = useTonAddress();

  const fetchBalance = async () => {
    switch (ticker) {
      case Ticker.TON:
        await tonClientStore.loadTonBalance(userAddress);
        break;
      case Ticker.RAFF:
        await tonClientStore.loadRaffBalance(userAddress);
        break;
      case Ticker.USDT:
        await tonClientStore.loadUsdtBalance(userAddress);
        break;
    }
  };

  const balance = useMemo(() => {
    switch (ticker) {
      case Ticker.TON:
        return tonClientStore.tonBalance;
      case Ticker.RAFF:
        return tonClientStore.raffBalance;
      case Ticker.USDT:
        return tonClientStore.usdtBalance;
      default:
        return 0;
    }
  }, [ticker]);

  return (
    <div
      className={s.funds}
      style={!isBottomMarginNeeded ? { marginBottom: "0" } : {}}
    >
      <p className={s.funds_text}>Your balance</p>
      <ParagraphSkeletonRow isLoading={tonClientStore.isBalanceFetchLoading}>
        <div className={s.funds_action} onClick={fetchBalance}>
          <p className={s.funds_value}>
            {balance && toFixedWithoutRounding(balance, 2)} {ticker}
          </p>
          <RefreshIcon />
        </div>
      </ParagraphSkeletonRow>
    </div>
  );
};
